export const SITE_EVENTS_CARD_FRENCH_LOCALE = {
  title: "Actions / Événements",
  collapseAll: "Tout réduire",
  expandAll: "Tout développer",
  filterEventCategories: "Filtrer les types d'événements",
  details: "Détails",
  creationDate: "Date de création",
  category: "Catégorie",
  operator: "Opérateur",
  priority: "Priorité",
  status: "Status",
  description: "Déscription",
  truncatedTitle: "Affichage partiel",
  truncated: "Trop de données à afficher",
};
